import { CheckName } from 'dashboard/models/check/check';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';
import { CountryCode } from 'lib/constants/locales';

export type DisallowedCountryCheckName =
  | CheckName.IdDisallowedCountryDetection
  | CheckName.IdNfcDisallowedCountryDetection;

export interface DisallowedCountryCheckConfig extends VerificationCheckConfig {
  check: DisallowedCountryCheckName;
  'disallowed-country-codes': CountryCode[];
  'match-associated-sovereignty': boolean;
}

export function isDisallowedCountryCheck(
  verificationCheck: VerificationCheckConfig,
): verificationCheck is DisallowedCountryCheckConfig {
  switch (verificationCheck.check) {
    case CheckName.IdDisallowedCountryDetection:
    case CheckName.IdNfcDisallowedCountryDetection:
      return true;
    default:
      return false;
  }
}
